import React from "react"
import { OutboundLink } from "gatsby-plugin-google-analytics"
import Layout from "../components/layout"
import SubheaderFinance from "../components/subheader-finance"
import Products from "../components/products"
import Packages from "../components/packages"
import SellBlock from "../components/sell-block"
import InstallBlock from "../components/install-block"
import GenericHero from "../components/generic-hero"
import SEO from "../components/seo"
import { Background } from "react-imgix"
import SubheaderCovid from "../components/subheader-covid"

import house from "../images/monitoring/house.png"

import shield from "../images/monitoring/shield.svg"
import shieldLight from "../images/monitoring/shield-light.svg"
import shieldLightCamera from "../images/monitoring/shield-light-camera.svg"

import check from "../images/monitoring/check.svg"
import dash from "../images/monitoring/dash.svg"

import tag from "../images/monitoring/tag.svg"

class Gizmo extends React.Component {
  constructor(props) {
    super(props)
    this.state = { active: "safety" }
    if (typeof window !== "undefined") {
      const fragment = window.location.hash.substr(1)
      if (!!fragment) {
        this.state = { active: window.location.hash.substr(1) }
      }
    }
    this.handleControl = this.handleControl.bind(this)
    this.showTags = this.showTags.bind(this)
  }

  componentDidMount() {
    const { active } = this.state
    const tags = document.querySelector(".gizmo .tags")
    this.tags = {
      safety: Array.prototype.slice.call(tags.querySelectorAll(".safety")),
      control: Array.prototype.slice.call(tags.querySelectorAll(".control")),
      video: Array.prototype.slice.call(tags.querySelectorAll(".video")),
    }
    this.controls = document.querySelectorAll(".gizmo__controls .control")

    const initialGroup = "safety"

    let initial = []
    if (active == "control") {
      initial = initial.concat(this.tags["control"])
    } else if (active == "video") {
      initial = initial.concat(this.tags["control"])
      initial = initial.concat(this.tags["video"])
    } else {
      initial = this.tags[initialGroup]
    }

    if (typeof window !== "undefined" && "onhashchange" in window) {
      window.onhashchange = () => {
        let name = window.location.hash.substr(1)
        if (!name) {
          // if nothing, use the default
          name = initialGroup
        }
        this.setState({
          active: name,
        })
        this.showTags(name)
      }
    }

    let timer = 500
    const delta = 1000 / initial.length
    initial.map((e) =>
      setTimeout(() => {
        e.classList.add("show")
      }, (timer += delta)),
    )
  }

  componentWillUnmount() {
    window.onhashchange = () => {}
  }

  handleControl(name) {
    this.setState({
      active: name,
    })

    this.showTags(name)

    if (typeof window !== "undefined") {
      history.pushState(null, null, `#${name}`)
    }
  }

  showTags(name) {
    if (name == "control") {
      this.tags["control"].map((e) => e.classList.add("show"))
      this.tags["video"].map((e) => e.classList.remove("show"))
    } else if (name == "video") {
      this.tags["control"].map((e) => e.classList.add("show"))
      this.tags["video"].map((e) => e.classList.add("show"))
    } else { // failsafe for 'safety'
      this.tags["control"].map((e) => e.classList.remove("show"))
      this.tags["video"].map((e) => e.classList.remove("show"))
    }
  }

  render() {
    const { active } = this.state
    return (
      <>
      <div className="gizmo__controls">
          <div className="controls">
            <div
              className={`control safety t7 ${ active == "safety" ? "active" : "" }`}
              onClick={() => this.handleControl("safety")}
            >
              Safety
            </div>
            <div
              className={`control controlled t7 ${ active == "control" ? "active" : "" }`}
              onClick={() => this.handleControl("control")}
            >
              Control
            </div>
            <div
              className={`control video t7 ${ active == "video" ? "active" : "" }`}
              onClick={() => this.handleControl("video")}
            >
              Video
            </div>
          </div>
        </div>
        <div className="gizmo">
          <img src={house} />
          <div className="tags">
            <div className="tag safety smoke left">Smoke Detector</div>
            <div className="tag safety water left">Water Sensor</div>
            <div className="tag safety motion left">Motion Sensor</div>
            <div className="tag safety window left">Window Sensor</div>
            <div className="tag safety touchscreen left">Touchscreen Panel</div>
            <div className="tag control lighting left">Smart Lighting</div>
            <div className="tag control thermostat left">Smart Thermostat</div>
            <div className="tag control garage right">Garage Door Opener</div>
            <div className="tag control door right">Smart Door Lock</div>
            <div className="tag video outdoorcam right">
              Wifi Outdoor Camera
            </div>
            <div className="tag video indoorcam right">Wifi Indoor Camera</div>
            <div className="tag video doorbell left">Doorbell Camera</div>
          </div>
        </div>
      </>
    )
  }
}

import smallShield from "../images/monitoring/small-shield.svg"
import signal from "../images/monitoring/signal.svg"
import bell from "../images/monitoring/bell.svg"

const MonitoringPage = () => {
  return (
    <Layout className="monitoring" headerSeparator>
      <SEO title="Home Security Systems with Cellular Monitoring" />
       <SubheaderFinance
        title="Monitoring Plans"
        price="starting at $39/mo"
        link="#target"
      />
      <div className="hero">
        <h1 className="experiences-header">24/7 Professional Monitoring Plans</h1>
        <Gizmo />
      </div>
      <div className="subhero__container">
        <div className="subhero">
          <h2 className="t10 t11--loose">
            Once you've configured your BrightSuite system, we'll match you with the service plan that covers all of your devices.
          </h2>
          <div id="target"></div>
        </div>
      </div>

      <div className="intro">
        <div className="intro__header t9">Plans Built for Your Lifestyle</div>
        <p className="intro__desc t5 t5--loose">
          Every BrightSuite plan comes standard with dedicated 4G LTE & Wi-Fi,
          encrypted wireless communication, and a live support agent available
          whenever you need help.
        </p>
        <div className="intro__features">
          <div className="feature">
            <img
              className="feature__icon"
              src={smallShield}
              alt="Professional Monitoring"
            />
            <div className="feature__desc">24/7 Monitoring</div>
          </div>
          <div className="feature">
            <img
              className="feature__icon"
              src={signal}
              alt="Reliable Network"
            />
            <div className="feature__desc">Secure Network</div>
          </div>
          <div className="feature">
            <img
              className="feature__icon"
              src={bell}
              alt="Installation Your Way"
            />
            <div className="feature__desc">App Notifications</div>
          </div>
        </div>
      </div>
      <div className="packages">
        <div className="package">
          <div className="package__icon">
            <img src={shield} alt="Lock" />
          </div>
          <div className="package__header t9">Safety</div>
          <div className="package__price t8">$39.99 / mo.</div>
          <div className="package__includes">
            <div className="includes">
              <img src={check} />
              <span>Break-in prevention</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Environmental &amp; Life Safety Monitoring</span>
            </div>
            <div className="includes except">
              <img src={dash} />
              <span>Control Lights &amp; Thermostat</span>
            </div>
            <div className="includes except">
              <img src={dash} />
              <span>Control door locks &amp; garage doors</span>
            </div>
            <div className="includes except">
              <img src={dash} />
              <span>4 Cameras with 3k Clips/mo.</span>
            </div>
            <div className="includes except">
              <img src={dash} />
              <span>Intelligent video object detection</span>
            </div>
          </div>
        </div>
        <div className="package">
          <div className="package__icon">
            <img src={shieldLight} alt="Control" />
          </div>
          <div className="package__header t9">Control</div>
          <div className="package__price t8">$44.99 / mo.</div>
          <div className="package__includes">
            <div className="includes">
              <img src={check} />
              <span>Break-in prevention</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Environmental &amp; Life Safety Monitoring</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Control Lights &amp; Thermostat</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Control door locks &amp; garage doors</span>
            </div>
            <div className="includes except">
              <img src={dash} />
              <span>4 Cameras with 3k Clips/mo.</span>
            </div>
            <div className="includes except">
              <img src={dash} />
              <span>Intelligent video object detection</span>
            </div>
          </div>
        </div>
        <div className="package">
          <div className="package__icon">
            <img src={shieldLightCamera} alt="Video" />
          </div>
          <div className="package__header t9">Video</div>
          <div className="package__price t8">$49.99 / mo.</div>
          <div className="package__includes">
            <div className="includes">
              <img src={check} />
              <span>Break-in prevention</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Environmental &amp; Life Safety Monitoring</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Control Lights &amp; Thermostat</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Control door locks &amp; garage doors</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>4 Cameras with 3k Clips/mo.</span>
            </div>
            <div className="includes">
              <img src={check} />
              <span>Intelligent video object detection</span>
            </div>
          </div>
        </div>
      </div>

      <Packages />
      <InstallBlock />
    </Layout>
  )
}

export default MonitoringPage
